export default __webpack_public_path__ + "static/media/federalBank.36b89647.jpeg";